<script setup lang="ts">
import { ContentLoader } from "vue-content-loader";
</script>

<template>
  <ContentLoader
    primary-color="#e8e8e8"
    secondary-color="#ecebeb"
  />
</template>
